var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.$t('message_beacon_type')))]),_vm._v(" "),_c('apexchart',{key:_vm.chartKey,attrs:{"type":"area","height":"350","options":_vm.chartOptions,"series":_vm.series}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c70aa920","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/Beacon/Analytics/Charts/MetricMessagesByTimeChart.vue
// module id = null
// module chunks = 